import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useRef, useEffect } from "react";
import { GetAndCreateProductLists } from "../../../../services/ProductService/AllProductList/AllProductServices";

const options = [
    "Last Update",
    "Full Name",
    "ID",
    "Created On",
    "Most Used",
    "Last Name",
    "Email Address",
];


export default function SortDropdown() {

    const [allProductLists , setAllProdcutLists] = useState([])
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const dropdownRef = useRef(null);

    
const getAllProductDetails = async() =>{

    try{
        const response = await GetAndCreateProductLists('GET',{})
        setAllProdcutLists(response.data)
    }catch{

    }
}

    const filteredOptions = options.filter((option) =>
        option.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Close dropdown when clicking outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="relative inline-block" ref={dropdownRef}>
            {/* Dropdown Button */}
            <p
                // className="flex items-center gap-2 px-3 py-1.5 border border-gray-300 bg-white rounded-md shadow-sm hover:bg-gray-100"
                onClick={() => setIsOpen(!isOpen)}
            >
                Created On
            </p>

            {/* Dropdown Menu */}
            {isOpen && (
                <div className="absolute -left-20 mt-2 w-52 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                    {/* Search Input */}
                    <div className="p-2">
                        <div className="relative">
                            <input
                                type="text"
                                placeholder="Search"
                                className="w-full pl-8 pr-2 py-1 text-sm border rounded-md focus:outline-none focus:ring"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <span className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500">
                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                            </span>
                        </div>
                    </div>

                    {/* Dropdown Items */}
                    <div className="max-h-56 overflow-y-auto">
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map((option) => (
                                <div
                                    key={option}
                                    className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                                    onClick={() => {
                                        setIsOpen(false);
                                        console.log("Selected:", option);
                                    }}
                                >
                                    {option}
                                </div>
                            ))
                        ) : (
                            <p className="text-center text-sm p-2 text-gray-500">No results</p>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
